import { QueryClientProvider } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "@/components/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import type { RouterContext } from "../router";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
});

function Root() {
  const { queryClient } = Route.useRouteContext();
  return (
    <QueryClientProvider client={queryClient}>
      {/* The sidebar's tooltips, when it is collapsed to icons. */}
      <TooltipProvider>
        <Outlet />
      </TooltipProvider>
      {/* Success messages, for every page: after a dialog closes, the action still says it worked. */}
      <Toaster />
    </QueryClientProvider>
  );
}
